import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { CUSTOMER_LOGIN_ENDPOINT } from '../utils/api';

function CustomerLogin() {
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!mobile || !password) {
      toast.error('Please enter both mobile and password');
      return;
    }

    try {
      const res = await axios.post(CUSTOMER_LOGIN_ENDPOINT, { mobile, password });

      if (res.data.success && res.data.token) {
        // ✅ Store token
        localStorage.setItem('token', res.data.token);

        // ✅ Try decoding to validate structure
        try {
          const decoded = JSON.parse(atob(res.data.token));
          console.log('🔓 Decoded token:', decoded);
        } catch (decodeError) {
          console.error('❌ Invalid Base64 token:', res.data.token);
          toast.error('Login token is invalid');
          return;
        }

        toast.success('Login successful!', { duration: 1200 });

        setTimeout(() => {
          navigate('/customer-dashboard');
        }, 1200); // ⏳ Wait for toast before redirect
      } else {
        toast.error(res.data.message || 'Login failed');
      }
    } catch (err) {
      console.error('Login error:', err);
      toast.error('Server error during login');
    }
  };

  const goBack = () => {
    navigate('/');
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="card shadow p-4" style={{ maxWidth: '400px', width: '100%' }}>
        <h3 className="text-center mb-4">Customer Login</h3>
        <input
          className="form-control mb-3"
          placeholder="Mobile"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
        />
        <input
          type="password"
          className="form-control mb-3"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button className="btn btn-success w-100 mb-2" onClick={handleLogin}>
          Login
        </button>
        <button className="btn btn-outline-secondary w-100" onClick={goBack}>
          ⬅️ Back
        </button>
      </div>
    </div>
  );
}

export default CustomerLogin;
